import { TOfferGroup } from '@lootboy/lib/types/deals';

import { ListContainer } from '~/components/atoms/ListContainer';

import { OfferTile } from '~/views/DealsView/OfferGroup/OfferTile';

import styles from './OfferGroup.module.scss';

type TOfferGroupProps = {
  offerGroup: TOfferGroup;
  claimedCodes?: Record<string, string>;
};

export function OfferGroup({
  offerGroup,
  claimedCodes,
}: TOfferGroupProps): JSX.Element {
  return (
    <li className={styles.container}>
      {offerGroup.offers.length === 1 ? (
        <OfferTile
          offer={offerGroup.offers[0]}
          code={claimedCodes?.[offerGroup.offers[0]._id]}
          isSingleOffer
        />
      ) : (
        <ListContainer className={styles.offersContainer}>
          {offerGroup.offers.map((offer) => (
            <li key={offer._id}>
              <OfferTile
                offer={offer}
                code={claimedCodes?.[offer._id]}
              />
            </li>
          ))}
        </ListContainer>
      )}
    </li>
  );
}
